import * as styles from "./PromotionCardImageTop.module.scss";

import React from "react";
import CurvedBorder from "../../../../components/borders/CurvedBorder";
import ProcessedImage from "../../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../../utils/colours";
import Button from "../../../common/Button";

export const PromotionCardImageTop: React.FC<DogsTrust.SignPostCardProps> = ({
	imgSrc,
	title,
	body,
	buttonLabel,
	buttonUrl,
	externalUrl,
	isOnDogListing,
}) => {
	const Border = CurvedBorder;
	return (
		<article
			className={
				isOnDogListing
					? styles.promocardwrapperdoglisting
					: styles.promocardwrapper
			}
		>
			<div className={styles.promocardtextcontainer}>
				<h2 data-variation="hideFromJumpLinks" className={styles.title}>
					{title}
				</h2>
				<p className={styles.promocardtext}>{body}</p>
				<div className={styles.border}>
					<Border
						rotation={0}
						fill={Colours.WHITE}
						width={"368"}
						height={"70"}
					/>
				</div>
			</div>
			<div className={styles.promocardimagecontainer}>
				<ProcessedImage
					className={styles.promocardimage}
					src={imgSrc}
					dimensions="400x300"
					alt={title}
					width={400}
					height={300}
					loading={"lazy"}
				/>
			</div>
			<Button
				variant={"tertiary"}
				size="small"
				url={buttonUrl}
				externalUrl={externalUrl}
			>
				{buttonLabel}
			</Button>
		</article>
	);
};

export default PromotionCardImageTop;
